export default "__VITE_ASSET__CdmjOUMS__"